import Box from './Box'

type ImageProps = React.ComponentProps<"img"> & {
  sx?: object;
};

export default function Image({ sx, ...props }: ImageProps) {
  return <Box component="img" sx={sx} {...props} />;
}
